import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-site-web',
  templateUrl: './site-web.component.html',
  styleUrls: ['./site-web.component.css']
})
export class SiteWebComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
